"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_RECORD_OWNER_EMAIL = exports.APP_NAMESPACE = void 0;
var APP_NAMESPACE = exports.APP_NAMESPACE = 'dify-lead-gen';

// Lead owner's GoDaddy email, sent as `recordOwnerEmail` on every hook submission (create AND
// upsert) so a lead that was manually reassigned in Salesforce is returned to the top of the
// assignment queue. The CRM backend resolves this email to a Salesforce User.Id and sets
// Lead.OwnerId (a raw 005 User id is NOT accepted upstream). Empty by default: external
// consumers of the hooks bundle pass their own owner via the `recordOwnerEmail` param of
// useSubmitDifyLead when they want owner routing; an empty value sends nothing so an existing
// owner is never clobbered. Loader-side twin of src/config/base.ts `defaultRecordOwnerEmail`
// (the app resolves that value at runtime via Switchboard; the isolated hooks bundle cannot
// import @config/@redux, so the default is duplicated here).
var DEFAULT_RECORD_OWNER_EMAIL = exports.DEFAULT_RECORD_OWNER_EMAIL = '';